'use client';

// eslint-disable-next-line @nx/enforce-module-boundaries
import {
  DomEventBusProvider,
  ExperimentsProvider,
  ScrollToTopOnNavigation,
  SSEProvider,
  TrackingContextsProvider,
} from '@hc-frontend/core-ui';
import React from 'react';

interface RootProvidersProps {
  children: React.ReactNode;
  tronContext: any;
  userwayWidgetFooterExperiment: string;
  userwayWidgetFooterTreatment: any;
  sseTreatment: any;
  sseUrl: string;
  sessionId: string;
}

export function RootProviders({
  children,
  tronContext,
  userwayWidgetFooterExperiment,
  userwayWidgetFooterTreatment,
  sseTreatment,
  sseUrl,
  sessionId,
}: RootProvidersProps) {
  return (
    <TrackingContextsProvider contexts={[tronContext]}>
      <DomEventBusProvider>
        <ScrollToTopOnNavigation />
        <ExperimentsProvider
          experiments={{
            [userwayWidgetFooterExperiment]: userwayWidgetFooterTreatment,
          }}
        >
          <SSEProvider
            treatment={sseTreatment}
            sseUrl={sseUrl}
            sessionId={sessionId}
          >
            {children}
          </SSEProvider>
        </ExperimentsProvider>
      </DomEventBusProvider>
    </TrackingContextsProvider>
  );
}
